/**
 * frontend/src/lib/analytics.js — Sprint 6A Prompt 7 PostHog events.
 *
 * track(event, props) sends ONLY the properties allowlisted for that event, and only as short
 * enum-like strings or booleans. No user ids, emails, names, artist names, query text, URLs or
 * claim codes ever leave through here (PostHog already knows the signed-in person via
 * posthog.identify in useAuth). Analytics failures never break the app.
 */

import posthog from 'posthog-js';

// event → allowed property names. An event not listed here is dropped.
export const EVENTS = {
  dig_search:            ['source', 'zero_creator_results', 'suggestion_clicked'],
  playlist_built:        [],
  playlist_track_added:  ['source', 'tag'],
  playlist_shared:       ['awarded'],
  track_played:          ['source'],
  artist_nominated:      [],
  claim_page_viewed:     [],
  claim_started:         [],
  claim_verify_attempt:  ['method', 'result'],
  claim_verified:        ['method'],
};

const SAFE_STRING = /^[a-z0-9_]{1,32}$/;

/** Keeps allowlisted props whose values are booleans or short lowercase tokens. */
export function cleanProps(event, props = {}) {
  const allowed = EVENTS[event];
  if (!allowed) return null;
  const out = {};
  for (const k of allowed) {
    const v = props[k];
    if (typeof v === 'boolean') out[k] = v;
    else if (typeof v === 'string' && SAFE_STRING.test(v)) out[k] = v;
  }
  return out;
}

export function track(event, props) {
  const clean = cleanProps(event, props);
  if (!clean) return;
  try { posthog.capture(event, clean); } catch (_) { /* analytics non-fatal */ }
}
